import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import FlyzoneObject from "../objects/FlyzoneObject";
import type { FlyzoneMapObject, MapLayerProps } from "../types";

type FlyzonesLayerProps = MapLayerProps<FlyzoneMapObject>;

const FlyzonesLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: FlyzonesLayerProps) => {
    const { items: layerItems } = useMapLayer({ items, selectedIds });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <FlyzoneObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    selected={selectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, onItemClick, onItemHover, onItemLeave, selectedIds],
    );

    return <pixiContainer label="flyzones-layer">{baseObjects}</pixiContainer>;
};

export default FlyzonesLayer;
